<template>
    <div class="image_recongnition">
        <div class="box filter">
            <div class="form_item">
                <span class="label">
                    店铺名称:
                </span>
                <div class="main">
                    <el-autocomplete v-model="shopName" :fetch-suggestions="querySearchAsync" placeholder="请输入店铺名称" @select="handleShopNameSelect" suffix-icon="el-icon-edit" />
                </div>
            </div>
            <div class="form_item">
                <span class="label">
                    时间选择:
                </span>
                <div class="main">
                    <time-select @change="timeChange" :time-value="time" :defaultTime="time" />
                </div>
            </div>
        </div>
        <el-tabs type="card" v-model="activeName" @tab-click="handleTabClick">
            <el-tab-pane label="图片列表" name="image">
                <load-com :status="loadStatus" v-if="showLoad" />
                <div class="box image_wrap">
                    <p v-if="!(shopId && this.time[0])">
                        请先选择店铺和时间
                    </p>
                    <template v-if="loadStatus.isDone && !showLoad">
                        <div class="btn_wrap">
                            <template v-if="editImgObj">
                                <el-button type="info" size="small" plain @click="handleCancelAddImgList">
                                    取消新增
                                </el-button>
                                <el-button size="small" plain @click="dialogAddImgVisible=true" :disabled="!(addImgList.length || delImgList.length)">
                                    新增
                                </el-button>
                            </template>
                            <el-button v-else type="primary" size="small" @click="handleAddBtnClick" :disabled="!checkedImageList.length">
                                添加
                            </el-button>
                            <el-button size="small" type="success" :plain="imageType!='page'" @click="handleImageTypeChange('page')">
                                PC端首页图
                            </el-button>
                            <el-button type="warning" size="small" :plain="imageType!='mpage'" @click="handleImageTypeChange('mpage')">
                                无线端首页图
                            </el-button>
                            <el-button type="info" size="small" :plain="imageType!='banner'" @click="handleImageTypeChange('banner')">
                                海报图
                            </el-button>
                        </div>
                        <el-row type="flex" v-if="activeTypeImageList.length">
                            <el-col :span="2" class="arrow_wrap">
                                <button class="el-carousel__arrow el-carousel__arrow--left" @click="handlePrev">
                                    <i class="el-icon-arrow-left" />
                                </button>
                            </el-col>
                            <el-col :span="20">
                                <el-carousel
                                    type="card"
                                    height="600px"
                                    :autoplay="false"
                                    @change="handleChange"
                                    class="carousel"
                                    arrow="never"
                                    ref="carousel">
                                    <el-carousel-item v-for="item in activeTypeImageList" :key="item.id" :class="{no_transition: isTransition}">
                                        <div class="img_container">
                                            <span class="icon_wrap">
                                                <i class="el-icon-circle-check" :style="{color: item.isChecked ? 'orange': 'white'}" @click.stop="item.isChecked=!item.isChecked" />
                                            </span>
                                            <div class="img_main">
                                                <img :src="item.thumb_image" style="width:400px;" @click.stop="showBigImage(item)">
                                            </div>
                                        </div>
                                    </el-carousel-item>
                                </el-carousel>
                            </el-col>
                            <el-col :span="2" class="arrow_wrap">
                                <button class="el-carousel__arrow el-carousel__arrow--right" @click="handleNext">
                                    <i class="el-icon-arrow-right" />
                                </button>
                            </el-col>
                        </el-row>
                        <p v-if="!activeTypeImageList.length">
                            暂无图片
                        </p>
                        <el-pagination
                            background
                            layout="total, prev, pager, next"
                            :total="total"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            v-if="total" />
                    </template>
                </div>
            </el-tab-pane>
            <el-tab-pane label="数据列表" name="data">
                <!-- {{ loadStatus2 }} -->
                <load-com :status="loadStatus2" v-if="showLoad2 && !loadStatus2.isEmpty" />
                <el-table style="width: 100%" :data="tableData">
                    <template slot="empty">
                        {{ !loadStatus2.isLoading&&!loadStatus2.isError?'暂无数据':'' }}
                    </template>
                    <el-table-column prop="shop.shopname" label="店铺名称" align="center" min-width="120" />
                    <el-table-column label="活动时间" align="center" width="120">
                        <template slot-scope="scope">
                            {{ scope.row.act_start_time.split(" ")[0] }}
                            <p>至</p>
                            {{ scope.row.act_end_time.split(" ")[0] }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="act_title" label="活动主题" />
                    <el-table-column prop="interest" label="利益点" />
                    <el-table-column prop="coupon" label="优惠券" />
                    <el-table-column label="聚划算">
                        <template slot-scope="scope">
                            <template v-if="scope.row.ju_num">
                                <a :href="getJuLink(scope.row)" target="_blank">
                                    {{ scope.row.ju_num }}
                                </a>
                            </template>
                            <span v-else>
                                {{ scope.row.ju_num }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="PC端首页图" min-width="120">
                        <template slot-scope="scope">
                            <span @click="handleShowImgDialog(scope.row)" class="img">
                                <i class="el-icon-picture-outline" v-for="item in scope.row.tagimage.filter(el => el.type=='page')" :key="item.id" />
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="无线端首页图" min-width="120">
                        <template slot-scope="scope">
                            <span @click="handleShowImgDialog(scope.row)" class="img">
                                <i class="el-icon-picture-outline" v-for="item in scope.row.tagimage.filter(el => el.type=='mpage')" :key="item.id" />
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="海报图" min-width="120">
                        <template slot-scope="scope">
                            <span @click="handleShowImgDialog(scope.row)" class="img">
                                <i class="el-icon-picture-outline" v-for="item in scope.row.tagimage.filter(el => el.type=='banner')" :key="item.id" />
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="act_type" label="活动类型">
                        <template slot-scope="scope">
                            {{ scope.row.act_type == "shop" ? "店铺活动" : "平台活动" }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="act_pace" label="活动节奏">
                        <template slot-scope="scope">
                            {{ scope.row.act_pace == "zs" ? "正式" : "预热" }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" />
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <p>
                                <el-button type="text" size="small" @click="handleEdit(scope.row)">
                                    编辑
                                </el-button>
                            </p>
                            <p>
                                <el-button type="text" size="small" style="color:#67c23a" @click="handleAddImg(scope.row)">
                                    新增图片
                                </el-button>
                            </p>
                            <p>
                                <el-button type="text" size="small" style="color:#f56c6c" @click="handleDel(scope.row)" :disabled="delLoading">
                                    删除
                                </el-button>
                            </p>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :total="tagTotal"
                    @current-change="handleCurrentTagChange"
                    :current-page="currentTagPage"
                    :page-size="tagPageSize"
                    v-if="tagTotal"
                    class="tag_pagination" />
            </el-tab-pane>
        </el-tabs>
        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" class="img_dialog" width="650px" @open="handleDialogOpen" @close="resize">
            <el-form :model="dialogForm" class="dialog_form" :inline="true" :rules="rules" ref="ruleForm">
                <el-form-item label="活动时间" :label-width="formLabelWidth" class="date_item" style="margin-bottom:0;">
                    {{ formatDate(dialogForm.time[0]) }} 至 {{ formatDate(dialogForm.time[1]) }}
                </el-form-item>
                <br>
                <el-form-item label="已选图片" :label-width="formLabelWidth" class="img_item">
                    <el-row :gutter="10">
                        <el-col :span="6" v-for="(item,index) in dialogForm.checkedImageList" :key="item.id">
                            <el-scrollbar wrap-class="list">
                                <span class="icon_wrap">
                                    <i class="el-icon-circle-check" :style="{color: item.isChecked ? 'orange': 'white'}" @click.stop="cancelCheckImage(item, index)" />
                                </span>
                                <img :src="item.thumb_image" style="width:100%">
                            </el-scrollbar>
                        </el-col>
                    </el-row>
                </el-form-item>
                <br>
                <el-form-item label="活动类型" :label-width="formLabelWidth" prop="act_type">
                    <el-select v-model="dialogForm.act_type" placeholder="请选择活动类型">
                        <el-option label="店铺活动" value="shop" />
                        <el-option label="平台活动" value="platform" />
                    </el-select>
                </el-form-item>
                <el-form-item label="活动节奏" :label-width="formLabelWidth" prop="act_pace">
                    <el-select v-model="dialogForm.act_pace" placeholder="请选择活动类型">
                        <el-option label="预热" value="yr" />
                        <el-option label="正式" value="zs" />
                    </el-select>
                </el-form-item>
                <el-form-item label="活动主题" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="dialogForm.act_title" class="textarea" />
                </el-form-item>
                <el-form-item label="利益点" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="dialogForm.interest" class="textarea" />
                </el-form-item>
                <el-form-item label="优惠券" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="dialogForm.coupon" class="textarea" />
                </el-form-item>
                <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="dialogForm.remark" class="textarea" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" :disabled="loading">
                    取 消
                </el-button>
                <el-button type="primary" @click="handleSureEdit" v-if="dialogType=='edit'" :loading="loading" :disabled="loading">
                    修 改
                </el-button>
                <el-button type="primary" @click="handleSureAdd" v-else :loading="loading" :disabled="loading">
                    新 建
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="图片列表" :visible.sync="dialogImgVisible" class="img_dialog">
            <p>PC端首页图</p>
            <el-row :gutter="10" v-if="imgList.filter(el => el.type=='page').length">
                <el-col :span="4" v-for="item in imgList.filter(el => el.type=='page')" :key="item.id">
                    <el-scrollbar wrap-class="list">
                        <img :src="item.thumb_image">
                    </el-scrollbar>
                </el-col>
            </el-row>
            <span v-else>
                未选择
            </span>
            <p>无线端首页图</p>
            <el-row :gutter="10" v-if="imgList.filter(el => el.type=='mpage').length">
                <el-col :span="4" v-for="item in imgList.filter(el => el.type=='mpage')" :key="item.id">
                    <el-scrollbar wrap-class="list">
                        <img :src="item.thumb_image">
                    </el-scrollbar>
                </el-col>
            </el-row>
            <span v-else>
                未选择
            </span>
            <p>海报图</p>
            <el-row :gutter="10" v-if="imgList.filter(el => el.type=='banner').length">
                <el-col :span="4" v-for="item in imgList.filter(el => el.type=='banner')" :key="item.id">
                    <el-scrollbar wrap-class="list">
                        <img :src="item.thumb_image">
                    </el-scrollbar>
                </el-col>
            </el-row>
            <span v-else>
                未选择
            </span>
        </el-dialog>
        <el-dialog title="新增图片列表" :visible.sync="dialogAddImgVisible" class="img_dialog" @close="resize">
            <p v-if="addImgList.length">
                新增图片
            </p>
            <el-row :gutter="10">
                <el-col :span="6" v-for="(item,index) in addImgList" :key="item.id">
                    <el-scrollbar wrap-class="list">
                        <span class="icon_wrap">
                            <i class="el-icon-circle-check" :style="{color: item.isChecked ? 'orange': 'white'}" @click.stop="cancelCheckImage(item, index)" />
                        </span>
                        <img :src="item.thumb_image">
                    </el-scrollbar>
                </el-col>
            </el-row>
            <p v-if="delImgList.length">
                删除图片
            </p>
            <el-row :gutter="10">
                <el-col :span="6" v-for="item in delImgList" :key="item.id">
                    <el-scrollbar wrap-class="list">
                        <span class="icon_wrap">
                            <i class="el-icon-circle-check" :style="{color: item.isChecked ? 'orange': 'white'}" @click.stop="delImgCheck(item)" />
                        </span>
                        <img :src="item.thumb_image">
                    </el-scrollbar>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogAddImgVisible = false" :disabled="loading">
                    取 消
                </el-button>
                <el-button type="primary" @click="handleSureEditImage" :loading="loading" :disabled="loading">
                    确 定
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="查看大图" :visible.sync="dialogBigImgVisible" class="img_dialog">
            <img :src="bigImage" style="width:100%">
        </el-dialog>
    </div>
</template>

<script>
import {
    ApiGetTuShopsList,
    ApiGetTuImageList,
    ApiGetTuImageTagList,
    ApiPostTuImageTagAdd,
    ApiGetTuImageTagDel,
    ApiGetcurrentUserApi,
    ApiPostTuImageTagEdit,
    ApiGetTuBigImageApi
} from "../api/api";
import TimeSelect from "./TimeSelect";
import LoadCom from "./LoadCom";
export default {
    name: 'ImageRecongnition',
    props: {
        msg: String
    },
    data() {
        return {
            loading: false,
            delLoading: false, // 删除列表
            loadStatus: {
                isLoading: false,
                isError: false,
                isEmpty: false,
                isDone: false,
                errMsg: ""
            },
            loadStatus2: {
                isLoading: false,
                isError: false,
                isEmpty: false,
                isDone: false,
                errMsg: ""
            },
            uid: "",
            shopName: "",
            shopId: "",
            time: [],
            total: 0,
            currentPage: 1,
            pageSize: 15,
            tagTotal: 0,
            currentTagPage: 1,
            tagPageSize: 15,
            imageType: "page", // 图片类型
            allImageListObj: {}, // 所有页数的图片列表
            dialogForm: {
                act_title: "",
                interest: "",
                coupon: "",
                act_type: "",
                act_pace: "",
                remark: "",
                time: [],
                checkedImageList: []
            },
            dialogFormVisible: false,
            dialogImgVisible: false,
            dialogAddImgVisible: false,
            dialogBigImgVisible: false,
            bigImage: "",
            dialogType: "",
            show: false,
            formLabelWidth: "80px",
            rules: {
                act_type: [
                    { required: true, message: '请选择活动类型', trigger: 'change' },
                ],
                act_pace: [
                    { required: true, message: '请选择活动区域', trigger: 'change' }
                ]
            },
            activeName: "image", // tab标签页名字
            isTransition: false,
            editImgObj: {},
            tableData: [],
            imgList: []
        };
    },
    computed: {
        showLoad() {
            return this.loadStatus.isLoading || this.loadStatus.isError || this.loadStatus.isEmpty;
        },
        showLoad2() {
            return this.loadStatus2.isLoading || this.loadStatus2.isError || this.loadStatus2.isEmpty;
        },
        // 当前页图片列表(所有图片类型)
        activeImageList() {
            if (this.allImageListObj[this.currentPage]) {
                return this.allImageListObj[this.currentPage];
            }
            return [];
        },
        // 被选中的图片列表
        checkedImageList() {
            let arr = [];
            for (let i in this.allImageListObj) {
                for (let j in this.allImageListObj[i]) {
                    for (let z of this.allImageListObj[i][j]) {
                        if (z.isChecked) {
                            arr.push(z);
                        }
                    }

                }
            }
            return arr;
        },
        // 当前页某个图片类型列表
        activeTypeImageList() {
            if (this.activeImageList[this.imageType]) {
                return this.activeImageList[this.imageType];
            }
            return [];
        },
        dialogTitle() {
            return this.dialogType == "add" ? "新建列表" : "编辑列表";
        },
        // 编辑时新增图片列表
        addImgList() {
            let arr = [];
            if (!this.editImgObj || !this.checkedImageList.length) {
                return arr;
            }
            for (let i of this.checkedImageList) {
                let bool = this.editImgObj.tagimage.some(el => {
                    return el.imageid == i.id;
                });
                if (!bool) {
                    arr.push(i);
                }
            }
            return arr;
        },
        // 编辑时删除图片列表
        delImgList() {
            let arr = [];
            if (!(this.editImgObj && this.editImgObj.tagimage)) {
                return arr;
            }
            for (let i of this.editImgObj.tagimage) {
                let bool = this.checkedImageList.some(el => {
                    return el.id == i.imageid;
                });
                if (!bool) {
                    i.isChecked = false;
                    arr.push(i);
                }
            }
            return arr;
        },
    },
    components: {
        TimeSelect,
        LoadCom
    },
    methods: {
        showBigImage(imgObj) {
            ApiGetTuBigImageApi({
                type: imgObj.type,
                imageurl: imgObj.localurl ? imgObj.localurl : imgObj.imgname
            }).then(res => {
                this.dialogBigImgVisible = true;
                this.bigImage = res;
            }).catch(err => {
                console.log(err);
                this.$message.error("获取大图失败,请重试");
            });
        },
        getJuLink(imgObj) {
            let timeStr = imgObj.act_start_time.split(" ")[0]+ "," + imgObj.act_end_time.split(" ")[0];
            return `${process.env.VUE_APP_DOMAIN}/jua/#/shopSearchAnalysis?time=${timeStr}&shopName=${imgObj.shopName}`;
        },
        // 获取用户信息
        getCurrentUserApi() {
            ApiGetcurrentUserApi().then(res => {
                this.uid = Number(res.user.uid);
            });
        },
        // 异步查店铺名称
        querySearchAsync(queryString, cb) {
            if (!String(queryString).trim()) {
                return;
            }
            ApiGetTuShopsList({shopname: String(queryString).trim()}).then(res => {
                let arr = res.shoplist.slice(0, 20);
                arr.forEach(el => {
                    el.value = el.shopname;
                    el.name = el.shopname;
                });
                cb(arr);
            });
        },
        // 选择了店铺名称之后触发
        handleShopNameSelect(item) {
            this.shopId = item.id;
            if (!(this.time && this.time[0])) {
                return;
            }
            this.currentPage = 1;
            this.editImgObj = null;
            this.GetTuImageList();
            this.GetTuImageTagList();
        },
        // 时间改变
        timeChange(time) {
            this.time = time;
            if (!this.shopId) {
                return;
            }
            this.editImgObj = null;
            this.currentPage = 1;
            this.GetTuImageList();
            this.GetTuImageTagList();
        },
        // 获取图片列表
        GetTuImageList() {
            this.loadStatus.isLoading = true;
            this.loadStatus.isDone = false;
            ApiGetTuImageList({
                shopid: this.shopId,
                start: this.time[0],
                end: this.time[1],
                page: this.currentPage,
                pageSize: this.pageSize
            }).then(res => {
                // eslint-disable-next-line no-console
                this.loadStatus.isLoading = false;
                this.loadStatus.isDone = true;
                this.total = res.total;
                if (res.total == 0) {
                    this.loadStatus.isEmpty = true;
                }
                let obj = {};
                this.setProps(res.banner, "banner");
                this.setProps(res.mpage, "mpage");
                this.setProps(res.page, "page");
                obj[this.currentPage] = {
                    banner: res.banner,
                    mpage: res.mpage,
                    page: res.page
                };
                this.allImageListObj = JSON.parse(JSON.stringify(Object.assign({}, this.allImageListObj, obj)));
                this.resize();
            }).catch(err => {
                this.loadStatus.isDone = true;
                this.loadStatus.isError = true;
                this.loadStatus.errMsg = err;
                // eslint-disable-next-line no-console
                console.log(err);
            });
        },
        // 设置属性
        setProps(arr, type) {
            for(let i of arr) {
                i.type = type;
                if (this.editImgObj) {
                    if (this.editImgObj.tagimage.some(el => el.imageid == i.id)) {
                        i.isChecked = true;
                        continue;
                    }
                }
                i.isChecked = false;
            }
        },
        // 获取图片数据列表
        GetTuImageTagList() {
            this.loadStatus2.isLoading = true;
            this.loadStatus2.isEmpty = false;
            this.loadStatus2.isDone = false;
            ApiGetTuImageTagList({
                shopid: this.shopId,
                uid: this.uid,
                start: this.time[0],
                end: this.time[1],
                page: this.currentPage,
                pageSize: this.pageSize
            }).then(res => {
                // eslint-disable-next-line no-console
                this.loadStatus2.isLoading = false;
                this.loadStatus2.isDone = true;
                this.tagTotal = res.total;
                if (!res.total) {
                    this.loadStatus2.isEmpty = true;
                }
                this.tableData = res.list;
            }).catch(err => {
                this.loadStatus2.isDone = true;
                this.loadStatus2.isError = true;
                this.loadStatus2.errMsg = err;
                // eslint-disable-next-line no-console
                console.log(err);
            });
        },
        formatDate(dateStr) {
            let date = new Date(dateStr);
            return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
        },
        handlePrev() {
            this.$refs.carousel.prev();
        },
        handleNext() {
            this.$refs.carousel.next();
        },
        resize() {
            this.$nextTick(() => {
                window.onresize();
            });
        },
        // Tab标签点击
        handleTabClick(tab) {
            if (this.activeName == "data") {
                this.isTransition = true;
                if (!this.loadStatus2.isDone && !this.loadStatus2.isLoading) {
                    this.GetTuImageTagList();
                }
            } else {
                this.resize();
            }
        },
        handleCurrentChange(curPage) {
            this.currentPage = curPage;
            if (!this.allImageListObj[this.currentPage]) {
                this.GetTuImageList();
                return;
            }
            this.resize();
        },
        handleCurrentTagChange(curPage) {
            this.currentTagPage = curPage;
        },
        handleChange(index) {
            this.isTransition = false;
        },
        // 点击添加按钮
        handleAddBtnClick() {
            this.dialogType = "add";
            this.dialogFormVisible = true;
        },
        setDialogFormWhenAdd() {
            this.dialogForm = {
                act_title: "",
                interest: "",
                coupon: "",
                act_type: "",
                act_pace: "",
                remark: "",
                time: this.time,
                checkedImageList: this.checkedImageList
            };
        },
        handleDialogOpen() {
            this.$nextTick(() => {
                this.$refs.ruleForm.resetFields();
                this.dialogForm.act_pace = "yr";
                if (this.dialogType == "edit") {
                    this.setDialogFormWhenEdit();
                } else {
                    this.setDialogFormWhenAdd();
                }
            });
        },
        // 取消选中的图片
        cancelCheckImage(item, index) {
            if (this.dialogType == "add" || this.dialogAddImgVisible) {
                this.activeTypeImageList.find(el => {
                    return el.id == item.id || el.id == item.imageid;
                }).isChecked = false;
                this.dialogForm.checkedImageList.splice(index, 1);
                !this.dialogForm.checkedImageList.length && (this.dialogFormVisible = false);
            } else {
                if (this.dialogForm.checkedImageList.filter(el => el.isChecked).length > 1) {
                    item.isChecked = !item.isChecked;
                    return;
                }
                this.$message.warning("最后一张啦,不能再删啦");
            }
            if (!(this.addImgList.length || this.delImgList.length)) {
                this.dialogAddImgVisible = false;
            }
        },
        // 点击按钮改变imageType后
        handleImageTypeChange(imageType) {
            this.imageType = imageType;
            this.resize();
        },
        // 修改图片信息
        handleEdit(listObj) {
            this.dialogType = "edit";
            this.editImgObj = listObj;
            this.dialogFormVisible = true;
        },
        setDialogFormWhenEdit() {
            this.editImgObj.tagimage.forEach(el => {
                el.isChecked = true;
            });
            this.dialogForm = JSON.parse(JSON.stringify({
                time: [this.editImgObj.act_start_time, this.editImgObj.act_end_time],
                act_title: this.editImgObj.act_title,
                interest: this.editImgObj.interest,
                coupon: this.editImgObj.coupon,
                act_type: this.editImgObj.act_type,
                act_pace: this.editImgObj.act_pace,
                remark: this.editImgObj.remark,
                checkedImageList: this.editImgObj.tagimage,
                id: this.editImgObj.id
            }));
        },
        // 删除图片信息
        handleDel(listObj) {
            this.delLoading = true;
            ApiGetTuImageTagDel({
                id: listObj.id
            }).then(res => {
                this.delLoading = false;
                this.$message.success(res.message);
                this.GetTuImageTagList();
            }).catch(err => {
                console.log(err);
                this.delLoading = false;
                this.$message.error("移除失败,请重试");
            });
        },
        // 添加图片信息
        handleSureAdd() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.PostTuImageTagAdd();
                } else {
                    return false;
                }
            });
        },
        // 编辑列表数据
        handleSureEdit() {
            let params = {
                id: this.dialogForm.id,
                start: this.dialogForm[0],
                end: this.dialogForm[1],
                act_type: this.dialogForm.act_type,
                act_pace: this.dialogForm.act_pace,
                image: []
            };
            for (let i of this.dialogForm.checkedImageList) {
                if (!i.isChecked) {
                    params.image.push({
                        id : i.id,
                        act: "delete"
                    });
                }
            }
            params.image = JSON.stringify(params.image);
            let arr = ["act_title", "interest", "coupon", "remark"];
            for (let i of arr) {
                // 是空也要传
                params[i] = this.dialogForm[i];
            }
            this.loading = true;
            ApiPostTuImageTagEdit(params).then(res => {
                this.dialogFormVisible = false;
                this.loading = false;
                this.$message.success("修改成功");
                this.GetTuImageTagList();
            }).catch(err => {
                this.loading = false;
                this.$message.success("修改失败请重试");
            });
        },
        // 确认编辑添加图片
        handleSureEditImage() {
            let arr = [];
            for (let i of this.addImgList) {
                arr.push({
                    imageid: i.id,
                    imageurl: i.localurl,
                    type: i.type,
                    act: "add"
                });
            }
            for (let i of this.delImgList) {
                arr.push({
                    id: i.id,
                    act: "delete"
                });
            }
            let isAllDelete = arr.every(el => {
                return el.act == "delete";
            });
            if (isAllDelete && arr.length == this.editImgObj.tagimage.length) {
                this.$message.warning("不能全部删光啦");
                return;
            }
            let params = {
                id: this.editImgObj.id,
                image: JSON.stringify(arr)
            };
            this.loading = true;
            ApiPostTuImageTagEdit(params).then(res => {
                this.dialogAddImgVisible = false;
                this.loading = false;
                this.$message.success("成功");
                this.handleCancelAddImgList();
                this.activeName = "data";
                this.GetTuImageTagList();
            }).catch(err => {
                this.loading = false;
                this.$message.success("失败请重试");
            });
        },
        PostTuImageTagAdd() {
            let params = {
                shopid: this.shopId,
                uid: this.uid,
                start: this.time[0],
                end: this.time[1],
                act_type: this.dialogForm.act_type,
                act_pace: this.dialogForm.act_pace
            };
            params.image = JSON.stringify(this.dialogForm.checkedImageList.map(el => {
                return {
                    imageid : el.id,
                    imageurl: el.localurl,
                    type: el.type
                };
            }));
            let arr = ["act_title", "interest", "coupon", "remark"];
            for (let i of arr) {
                if (this.dialogForm[i]) {
                    params[i] = this.dialogForm[i];
                }
            }
            this.loading = true;
            ApiPostTuImageTagAdd(params).then(res => {
                this.dialogFormVisible = false;
                this.loading = false;
                this.$message.success("添加成功");
                this.resetAllImageListObj();
                this.GetTuImageTagList();
            }).catch(err => {
                this.loading = false;
                this.$message.success("添加失败请重试");
            });
        },
        handleShowImgDialog(imgObj) {
            this.dialogImgVisible = true;
            this.imgList = imgObj.tagimage;
        },
        // 点击新增图片按钮
        handleAddImg(imgObj) {
            this.editImgObj = imgObj;
            this.activeName = "image";
            this.shopName = imgObj.shop.shopname;
            this.shopId = imgObj.shop.id;
            this.time.splice(0, this.time.length);
            this.time.push(imgObj.act_start_time.split(" ")[0], imgObj.act_end_time.split(" ")[0]);
            this.GetTuImageList();
        },
        // 点击取消新增按钮
        handleCancelAddImgList() {
            this.editImgObj = null;
            this.resetAllImageListObj();
        },
        // 设置所有图片的isChecked为false
        resetAllImageListObj() {
            for (let i in this.allImageListObj) {
                for (let j in this.allImageListObj[i]) {
                    for (let z of this.allImageListObj[i][j]) {
                        z.isChecked = false;
                    }
                }
            }
        },
        // 取消删除图片
        delImgCheck(item) {
            for (let i in this.allImageListObj) {
                let obj = this.allImageListObj[i][item.type].find(el => {
                    return el.id == item.imageid;
                });
                if (obj) {
                    obj.isChecked = true;
                }
            }
            if (!(this.delImgList.length || this.addImgList.length)) {
                this.dialogAddImgVisible = false;
            }
        }
    },
    mounted() {
        this.getCurrentUserApi();
        window.onresize = function(){
            let seletor = ".carousel .el-carousel__container";
            if (document.querySelector(seletor)) {
                let offsetWidth = document.querySelector(seletor).offsetWidth;
                let imgArr = document.querySelectorAll(seletor + " img");
                for (let i of imgArr) {
                    i.style.width = offsetWidth * 0.5 + "px";
                }
            }
            let dialogSeletor = ".dialog_carousel .el-carousel__container";
            if (document.querySelector(dialogSeletor)) {
                let dialogOffsetWidth = document.querySelector(dialogSeletor).offsetWidth;
                let dialogImgArr = document.querySelectorAll(dialogSeletor + " img");
                for (let i of dialogImgArr) {
                    i.style.width = dialogOffsetWidth * 0.5 + "px";
                }
            }
        };
        this.resize();
    // eslint-disable-next-line no-console
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.image_recongnition {
    height: 100%;
    min-width: 950px;
}
.image_wrap {
    text-align: center;
}
.img_container{
    height: 100%;
    position:relative;
    overflow: hidden;
    margin: 0 auto;
}
.img_container .img_main {
    position:absolute;
    top: 0px;
    bottom: 0;
    overflow-y: auto;
}
.icon_wrap {
    position:absolute;
    top: 0;
    right: 0;
    z-index: 2;
    font-size: 30px;
    line-height: 0;
}
.icon_wrap i {
    background: rgba(0,0,0,0.4);
}
/* .img_container img {
    width: 400px;
} */
.box {
    padding: 15px;
    background: #fff;
}
.image_wrap.box {
    padding: 15px 0;
    border-left: 1px solid #e4e7ed;
    border-right: 1px solid #e4e7ed;
}
.filter {
    margin-bottom: 15px;
}
.form_item {
    display: flex;
    margin-right: 15px;
}
.form_item:first-of-type {
    margin-bottom: 15px;
}
.form_item .label {
    flex-shrink: 0;
    margin-top: 8px;
    text-align: right;
}
.form_item .main {
    margin-left: 15px;
}
.image_wrap >div.wrap {
    padding-bottom: 15px;
}
.dialog_form {
    display: inline-block;
}
.dialog_form .el-form-item__content {
    width: 200px;
}
.dialog_form .img_item {
    width: 100%;
}
.dialog_form .img_item .el-form-item__content {
    width: 100%;
}
.dialog_form .date_item .el-form-item__content {
    width: 488px;
}
.arrow_wrap {
    position: relative;
}
.arrow_wrap button{
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0 auto;
}
.el-tabs--card>.el-tabs__header {
    margin: 0;
}
.el-tabs__content {
    background: #fff;
}
.el-tabs__nav {
    overflow: hidden;
}
.el-tabs__header .el-tabs__item{
    background: white;
}
.el-tabs__header .el-tabs__item.is-active {
    background: #409EFF;
    color: white;
}
.image_recongnition .no_transition {
    transition: none;
}
.btn_wrap {
    margin-bottom: 15px;
}
.image_recongnition .el-carousel__indicator {
    padding: 4px;
}
.el-pagination {
    margin-top: 10px;
    text-align: center;
}
.tag_pagination {
    margin: 15px 0;
}
span.img {
    cursor: pointer;
    font-size: 20px;
    color: #409EFF;
}
span.img i {
    margin-right: 3px;
}
span.img i:last-child {
    margin-right: 0px;
}
.img_dialog .el-dialog{
    margin: 0 !important;
    width: 100% !important;
    height: 100vh;
    border: none;
    margin-bottom: 0;
    border-radius: 0;
    display: flex;
    flex-direction: column;
}
.img_dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
    padding: 0 20px 20px 20px;
}
.img_dialog .el-dialog__header {
    padding-bottom: 0;
}
.img_dialog p {
    padding: 10px 0;
}
.img_dialog img {
    width: 100%;
}
.list {
    max-height: 300px;
}
.el-tabs {
    margin-bottom: 15px;
}
.image_recongnition a{
    text-decoration: none;
    color: #409EFF;
}
</style>
